/* @flow */

import moment from 'moment';

const getFiltroIntervaloMes = () => ({
    dataInicial: moment().format('Y-MM-01'),
    dataFinal: moment().endOf('month').format('Y-MM-DD'),
});

export default getFiltroIntervaloMes;
